import { createContext } from "react";

const RoundDataContext = createContext(null);
const RoundSettingsContext = createContext(null);

export { RoundDataContext, RoundSettingsContext };
